import { HeadCell } from "../../../components/common/table/CustomTable";

/**
 * Returns headers for BL Import table.
 *
 * @param {boolean} isAdminUser - Indicates is the logged user is admin
 * @returns - The headers
 */
export const getHeadersBLImportTable = (isAdminUser: boolean): HeadCell[] => {
  let headers: HeadCell[] = [];

  headers = [
    {
      disablePadding: false,
      id: "number",
      label: "#",
      numeric: false,
    },
    {
      disablePadding: false,
      id: "id",
      label: "ID",
      numeric: false,
      hidden: true,
    },
    {
      disablePadding: false,
      id: "hbl",
      label: "HBL",
      numeric: false,
      width: '140PX'
    },
    {
      disablePadding: false,
      id: "embarcador",
      label: "EMBARCADOR",
      numeric: false,
      width: "200px",
    },
    {
      disablePadding: false,
      id: "origen",
      label: "ORIGEN",
      numeric: false,
    },
    {
      disablePadding: false,
      id: "eta",
      label: "ETA",
      numeric: false,
    },
    {
      disablePadding: false,
      id: "mrn",
      label: "MRN",
      numeric: false,
    },
    {
      disablePadding: false,
      id: "fecha_de_descarga",
      label: "FECHA DE DESCARGA",
      numeric: false,
      hidden: !isAdminUser,
    },
    {
      disablePadding: false,
      id: "local_client",
      label: "local client",
      numeric: false,
      width: "200px",
      hidden: !isAdminUser,
    },
    {
      disablePadding: false,
      id: "ruc_local_client",
      label: "ruc local client",
      numeric: false,
      hidden: !isAdminUser,
    },
    {
      disablePadding: false,
      id: "download_bl",
      label: "DESCARGAR BL",
      numeric: false,
    },
    {
      disablePadding: false,
      id: "descargar_acta",
      label: "DESCARGAR ACTA",
      numeric: false,
      hidden: !isAdminUser,
    },
    {
      disablePadding: false,
      id: "download_carta",
      label: "DESCARGAR CARTA",
      numeric: false,
    },
    {
      disablePadding: false, 
      id: 'download_ecas', 
      label: 'DESCARGAR ECAS',
      numeric: false,
    },
    {
      disablePadding: false,
      id: "upload_document",
      label: "SUBIR DOCUMENTO",
      numeric: false,
      hidden: !isAdminUser,
    },
    {
      disablePadding: false,
      id: "upload_ecas",
      label: "SUBIR ECAS",
      numeric: false,
      hidden: !isAdminUser,
    },
    {
      disablePadding: false,
      id: "enable_ecas",
      label: "HABILITAR DESCARGA ECAS",
      numeric: false,
      hidden: !isAdminUser,
    },
  ];

  return headers;
};
